module.exports = __webpack_public_path__ + "static/media/back.880e5581.webp";